<template>
  <section class="mid-section" id="call-to-action">
    <div class="container">
      <slot name="main-body"></slot>

      <div class="d-flex justify-content-around mobile-wrap">
        <div class="text-box d-flex">
          <img src="../../../public/img/homepage/icon-user.png" alt="user" />
          <slot name="register-profile"></slot>
          <router-link to @click.native="openModal" ref="register-link" i
            ><i class="fas fa-angle-double-right"></i
          ></router-link>
        </div>
      </div>
    </div>

    <CustomMainModal @close="closeModal" v-show="showModal">
      <template v-slot:header>
        <h5 style="color: #343a40">Register Candidate</h5>
      </template>
      <Signin
        v-if="showLogin"
        @go-to-register="openModal"
        @go-to-reset-password="openModal"
      ></Signin>
      <Register
        v-if="showRegister"
        @go-to-login="openModal"
        @close="showModal = false"
        @emailVerification="(openEmailVerification = true), (showRegister = false)"
      ></Register>
      <ResetPassword v-if="showResetPassword" @close="showModal = false"></ResetPassword>
      <VerificationCode
        v-if="openEmailVerification"
        @prevStep="(showRegister = true), (openEmailVerification = false)"
      ></VerificationCode>
    </CustomMainModal>
  </section>
</template>

<script>
import CustomMainModal from '@/components/Modals/CustomMainModal';
import Signin from '@/components/Signin/Signin';
import Register from '@/components/Register/Register';
import ResetPassword from '@/components/ResetPassword/ResetPassword';
import VerificationCode from '@/components/SearchJob/VerificationCode';

export default {
  components: { CustomMainModal, Signin, Register, ResetPassword, VerificationCode },
  data: () => ({
    modalTitle: '',
    showModal: false,
    showResetPassword: false,
    showLogin: false,
    showRegister: false,
    openEmailVerification: false,
  }),
  methods: {
    openModal(e) {
      this.showModal = true;

      if (e.target.id == 'login-btn') {
        this.modalTitle = 'Log In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      }

      if (this.$refs['register-btn']) {
        this.modalTitle = 'Register';
        this.showLogin = false;
        this.showResetPassword = false;
        this.showRegister = true;
      }

      if (this.$refs['register-link']) {
        this.modalTitle = 'Register';
        this.showRegister = true;
        this.showLogin = false;
        this.showResetPassword = false;
      }

      if (e.target.id == 'forgotten-password') {
        this.modalTitle = 'Reset Password';
        this.showRegister = false;
        this.showLogin = false;
        this.showResetPassword = true;
      }

      if (e.target.id == 'already-have-account') {
        this.modalTitle = 'Log In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      }
    },
    closeModal() {
      this.showModal = false;
      this.showResetPassword = false;
      this.showLogin = false;
      this.showRegister = false;
      this.openEmailVerification = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';

/* .container {
  max-width: 1320px;
} */

.mid-section {
  padding: 60px 0;
  background: hsl(23, 100%, 47%);
  color: #fff;
  margin-bottom: 40px;
  img {
    width: 56px;
    height: 65px;
    flex-shrink: 0;
    margin: 20px 20px 0 0;
  }
  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 30px;
  }
  p {
    text-align: center;
    font-family: $font-family-sans-lato;
    font-size: 18px;
  }
  .text-box {
    margin-top: 80px;
    width: 365px;
    position: relative;
    .text {
      h3 {
        text-transform: uppercase;
        font-size: 22px;
      }
      p {
        text-align: left;
        font-family: $font-family-sans-lato;
        font-size: 16px;
      }
    }
    a {
      position: absolute;
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      line-height: 40px;
      background: #424242;
      color: #fff;
      text-decoration: none;
      text-align: center;
      top: 50%;
      right: -35px;
      transform: translate(0, -50%);
    }
  }
}

@media only screen and (max-width: 576px) {
  /* .latest-ads {
    .single {
      flex-wrap: wrap;
      img {
        display: none;
      }
      .job-info {
        width: 100%;
        margin-bottom: 12px;
      }
      .tagline {
        margin: 12px 0 0 0 !important;
        width: 100%;
        text-align: center;
      }
      .location {
        margin: 0;
        color: #666;
        width: 48%;
        text-align: left;
        i {
          display: none;
        }
        &:nth-last-of-type(3) {
          text-align: right;
        }
      }
    }
  } */
  .mid-section {
    .mobile-wrap {
      flex-wrap: wrap;
    }
    .text-box {
      width: 290px;
    }
  }
}

@media only screen and (max-width: 576px) {
  /* .latest-ads {
    .single {
      flex-wrap: wrap;
      img {
        display: none;
      }
      .job-info {
        width: 100%;
        margin-bottom: 12px;
      }
      .tagline {
        margin: 12px 0 0 0 !important;
        width: 100%;
        text-align: center;
      }
      .location {
        margin: 0;
        color: #666;
        width: 48%;
        text-align: left;
        i {
          display: none;
        }
        &:nth-last-of-type(3) {
          text-align: right;
        }
      }
    }
  } */
  .mid-section {
    .mobile-wrap {
      flex-wrap: wrap;
    }
    .text-box {
      width: 290px;
    }
  }
}
</style>
